<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Sponsor Pribadi Ceria</div>
		</div>
		
		<div class="mt-2 d-flex flex-wrap justify-space-between">
			<v-col cols="12" sm="4" md="3" lg="2" class="px-0">
				<v-autocomplete
					placeholder="Pilih Kode Mitra"
					outlined
					dense
					background-color="white"
					class="rounded-xl date-no-border"
					no-data-text="Tidak ada data"
					color="primary"
					hide-details="auto"
					:items="cloneList"
					item-text="network_code"
					item-value="network_code"
					v-model="network_code"
					@change="getData()">
				</v-autocomplete>
			</v-col>
		</div>
		<div class="mt-2">
			<v-card class="pa-3 mb-4 elevation-0 rounded-xl hover-shadow bg-primary-light">
				<v-row v-if="sponsorData" class="d-flex align-center justify-space-between">
					<v-col cols="12" sm="8" md="9">
						<v-row>
							<v-col cols="12" sm="4" md="4">
								<div class="d-flex align-center">
									<v-icon class="cl-grey" x-large >mdi-account-circle-outline</v-icon>
									<div class="d-block pl-4">
										<div class="font-size-11 cl-grey font-weight-500">Kode Mitra</div>
										<span class="font-size-12 primary--text font-weight-bold">{{ sponsorData.network_code }}</span>
									</div>
								</div>
							</v-col>
							<v-col cols="12" sm="4" md="3">
								<div class="d-flex align-center">
									<v-icon class="cl-grey" x-large>mdi-account-network-outline</v-icon>
									<div class="d-block pl-4">
										<div class="font-size-11 cl-grey font-weight-500">Level</div>
										<span class="font-size-12 primary--text font-weight-bold">{{ sponsorData.level }}</span>
									</div>
								</div>
							</v-col>
							<v-col cols="12" sm="4" md="3">
								<div class="d-flex align-center">
									<v-icon class="cl-grey" x-large>mdi-account-group-outline</v-icon>
									<div class="d-block pl-4">
										<div class="font-size-11 cl-grey font-weight-500">Sponsoring</div>
										<span class="font-size-12 primary--text font-weight-bold">{{ sponsorData.total_sponsoring }}</span>
									</div>
								</div>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" sm="4" md="3" class="text-right my-auto" v-if="sponsorData.level > 0">
						<v-btn depressed color="white rounded-xl" @click="backSponsor(sponsorData.sponsor_network_id, sponsorData.sponsor_network_code)">
							<span class="pr-2 secondary--text text-capitalize">Level Sebelumnya</span>
							<v-icon class="secondary--text">mdi-arrow-up-circle</v-icon>
						</v-btn>
					</v-col>
				</v-row>
			</v-card>

			<div class="mt-3" v-if="!loading">
				<v-row v-if="sponsorList.length > 0">
					<v-col cols="12" sm="12" md="12">
						<v-card class="pa-3 mb-3 elevation-0 rounded-xl hover-shadow" v-for="sponsor in sponsorList" :key="sponsor.network_id">
							<v-row class="cursor-pointer" @click="getSponsor(sponsor.network_id, sponsor.network_code)">
								<v-col cols="6" sm="2" md="1" class="pr-3 pr-sm-0 pr-md-3 my-auto">
									<v-img height="55" width="55" class="user-img mx-auto rounded-pill" :src="(sponsor.image) ? sponsor.image : '/assets/image/profile-pict.png'"></v-img>
								</v-col>
								<v-col cols="6" sm="3" md="2">
									<div>
										<div class="font-size-10 cl-primary font-weight-600">{{ sponsor.network_code }}</div>
										<div class="font-size-10 text-capitalize cl-secondary font-weight-500">{{ sponsor.name }}</div>
										<div class="font-size-10 cl-grey">{{ sponsor.city_name ? sponsor.city_name : '-' }}</div>
									</div>
								</v-col>
								<v-col cols="6" sm="3" md="2">
									<div class="pt-0">
										<div class="font-size-10 cl-grey">Tgl. Pendaftaran</div>
										<div class="font-size-10 cl-secondary font-weight-500">{{ sponsor.join_date | toDate }}</div>
									</div>
								</v-col>
								<v-col cols="6" sm="4" md="3">
									<div class="pt-0">
										<div class="font-size-10 cl-grey">Email</div>
										<div class="font-size-10 cl-secondary font-weight-500">{{ sponsor.email | emptyData }}</div>
									</div>
								</v-col>
								<v-col cols="6" sm="4" md="2">
									<div class="pt-0">
										<div class="font-size-10 cl-grey">Nomor HP</div>
											<div class="font-size-10 cl-secondary font-weight-500">{{ sponsor.mobilephone | emptyData }}</div>
										</div>
								</v-col>
								<v-col cols="6" sm="2" md="2">
									<div class="pt-0 text-sm-center">
										<div class="font-size-10 cl-grey">Sponsoring</div>
										<div class="font-size-10 cl-secondary font-weight-600">{{ sponsor.total_sponsoring | toNumber }}</div>
									</div>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>

				<div class="mt-3" v-if="sponsorList.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data sponsor pribadi yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>

				<div v-if="sponsorList.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="sponsorPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ sponsorPagination.total_display }} data dari total {{ sponsorPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-select :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" item-color="red darken-3" @input="changeLimit"></v-select>
						</v-col>
					</v-row>
				</div>
			</div>

			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			network_id: '',
			network_code: '',
			networkType: null,
			kemitraan: [
				{
					type: 'pramitra',
					color: '#03bb5a',
					belanja: '0',
					badges: '',
					classText: 'mitra-pra'
				},
				{
					type: 'silver',
					color: '#688389',
					belanja: '1.300.000',
					badges: '/assets/icon/silver.svg',
					classText: 'mitra-silver'
				},
				{
					type: 'gold',
					color: '#6e490f',
					belanja: '3.900.000',
					badges: '/assets/icon/gold.svg',
					classText: 'mitra-gold'
				},
				{
					type: 'diamond',
					color: '#2a4fd6',
					belanja: '13.000.000',
					badges: '/assets/icon/diamond.svg',
					classText: 'mitra-diamond'
				}
			],
		}
	},
	computed: {
		...mapState('jaringan', ['sponsorList', 'sponsorPagination', 'sponsorData']),
		...mapState('autentikasi', ['userData']),
		...mapState('opsi', ['cloneList']),
	},
	methods: {
		...mapActions('jaringan', ['getSponsorList']),
		...mapActions('opsi', ['getCloneList']),

		getSponsor(id, code) {
			this.network_id = id
			this.network_code = code
			this.getData()
		},
		backSponsor(id, code) {
			this.network_id = id
			this.network_code = code
			this.page = 1
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		getData() {
			this.loading = true
			let params = {limit:this.limit, page: this.page}
			params.plan = 'ceria'
			// if (this.network_id) {
			// 	params.network_id = this.network_id
			// }
			if (this.network_code) {
				params.network_code = this.network_code
			}
			this.getSponsorList(params).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
	},
	async created(){
		this.$store.dispatch('setPageTitle', `Sponsor Pribadi Ceria`)
		this.network_code = this.userData.member_network_code
		await this.getCloneList({ plan: 'ceria' })
		this.getData()
	},
};
</script>

